
const getAvailableLearningOutcomes = (params) => {
    let availableLearningOutcomes = {}
    params.department.submittedPrograms.map(program => {
        let programMappedSlos = params.mappedSlos[program.programId]
        
        if (!(program.programId in availableLearningOutcomes)) {
            availableLearningOutcomes[program.programId] = []
        }

        let theme = params.theme
        params.programLearningOutcomes[params.departmentId].learningOutcomes[program.programId].map(slo => {
            let mappedSlo = programMappedSlos[slo.sloId]
            if (mappedSlo.firstTheme === theme.name && mappedSlo.firstThemeAnswer === 'yes') {
                availableLearningOutcomes[program.programId].push(slo)
            } else if (mappedSlo.secondTheme === theme.name && mappedSlo.secondThemeAnswer === 'yes') {
                availableLearningOutcomes[program.programId].push(slo)
            } else if (mappedSlo.thirdTheme === theme.name && mappedSlo.thirdThemeAnswer === 'yes') {
                availableLearningOutcomes[program.programId].push(slo)
            }
        })
    })
    return availableLearningOutcomes
}

export function formatAssessmentPostData(appData) {
    console.log(appData)
    let formattedAssessmentData = []
    let availableLearningOutcomes = getAvailableLearningOutcomes({
        departmentId: appData['departmentId'], 
        department: appData['department'], 
        mappedSlos: appData['mappedSlos'], 
        programLearningOutcomes: appData['programLearningOutcomes'], 
        theme: appData['theme'],
    })
    const dt = new Date()
    const department = appData.department
    const activePrograms = appData.activePrograms
    const departmentId = appData.departmentId
    const reviewYear = appData.reviewYear
    const theme = appData.theme
    const currentUser = appData.currentUser
    const step1DataStore = appData.step1DataStore
    const step2DataStore = appData.step2DataStore
    const step4DataStore = appData.step4DataStore
    const step5Tab1DataStore = appData.step5Tab1DataStore
    const step5Tab2DataStore = appData.step5Tab2DataStore
    const step7Tab1DataStore = appData.step7Tab1DataStore
    const step7Tab2DataStore = appData.step7Tab2DataStore

    const step1CompletionData = appData.step1CompletionData
    const step2CompletionData = appData.step2CompletionData
    const step3CompletionData = appData.step3CompletionData
    const step4CompletionData = appData.step4CompletionData
    const step5CompletionData = appData.step5CompletionData
    const step6CompletionData = appData.step6CompletionData
    const step7CompletionData = appData.step7CompletionData
    const step7Tab2CompletionData = appData.step7Tab2CompletionData


    department.submittedPrograms?.map((p,k) => {
        if (activePrograms[p.programId] === 'yes') {
            let programAssessment = {
                departmentId: parseInt(departmentId),
                programId: p.programId,
                reviewYear: reviewYear,
                themeId: theme.themeId,
                createdBy: currentUser,
                dateCreated: dt.toISOString(),
                modifiedBy: currentUser,
                dateModified: dt.toISOString()
            }
            // TODO: We need to check if the step was modified FIRST
            //       before we just set the create/modify fields
            //       Otherwise those are set with no step data
            let step1Data = step1DataStore[p.programId]
            if (step1Data) {
                let s1Data = {
                    createdBy: currentUser,
                    dateCreated: dt.toISOString(),
                    modifiedBy: currentUser,
                    dateModified: dt.toISOString()
                }
                if (step1CompletionData[p.programId].completed) {
                    s1Data["completed"] = step1CompletionData[p.programId].completed
                    s1Data["dateCompleted"] = step1CompletionData[p.programId].dateCompleted
                    s1Data["completedBy"] = step1CompletionData[p.programId].completedBy
                } else {
                    s1Data["completed"] = false
                    s1Data["dateCompleted"] = ""
                    s1Data["completedBy"] = ""
                }
                let s1SloData = []
                availableLearningOutcomes[p.programId].map(slo => {
                    if (slo.sloId in step1Data) {
                        s1SloData.push({
                            sloId: slo.sloId,
                            focusQuestion: step1Data[slo.sloId].s1q1,
                        })
                    }
                })
                if (s1SloData.length > 0) {
                    s1Data["learningOutcomes"] = s1SloData
                }
                programAssessment["step1Data"] = s1Data
            } // --end step 1

            let step2Data = step2DataStore[p.programId]
            if (step2Data) {
                let s2Data = {
                    createdBy: currentUser,
                    dateCreated: dt.toISOString(),
                    modifiedBy: currentUser,
                    dateModified: dt.toISOString()
                }
                if (step2CompletionData[p.programId].completed) {
                    s2Data["completed"] = step2CompletionData[p.programId].completed
                    s2Data["dateCompleted"] = step2CompletionData[p.programId].dateCompleted
                    s2Data["completedBy"] = step2CompletionData[p.programId].completedBy
                } else {
                    s2Data["completed"] = false
                    s2Data["dateCompleted"] = ""
                    s2Data["completedBy"] = ""
                }
                let s2SloData = []
                availableLearningOutcomes[p.programId].map(slo=> {
                    if (slo.sloId in step2Data) {
                        s2SloData.push({
                            sloId: slo.sloId,
                            toolDescription: step2Data[slo.sloId].toolDescription,
                            coursesAssessed: step2Data[slo.sloId].coursesAssessed,
                            brightspaceAutomation: step2Data[slo.sloId].brightspaceAutomation,
                            hypotheticalAnalysis: step2Data[slo.sloId].hypotheticalAnalysis
                        })
                    }
                })
                if (s2SloData.length > 0) {
                    s2Data["learningOutcomes"] = s2SloData
                }
                programAssessment["step2Data"] = s2Data
            } // --end step 2
            
            if (p.programId in step3CompletionData) {
                let s3Data = {
                    assessmentToolUsed: step3CompletionData[p.programId].completed,
                    createdBy: currentUser,
                    dateCreated: dt.toISOString(),
                    modifiedBy: currentUser,
                    dateModified: dt.toISOString()
                }

                if (step3CompletionData[p.programId].completed) {
                    s3Data["completed"] = step3CompletionData[p.programId].completed
                    s3Data["dateCompleted"] = step3CompletionData[p.programId].dateCompleted
                    s3Data["completedBy"] = step3CompletionData[p.programId].completedBy
                } else {
                    s3Data["completed"] = false
                    s3Data["dateCompleted"] = ""
                    s3Data["completedBy"] = ""
                }

                programAssessment["step3Data"] = s3Data
            } // --end step 3

            let step4Data = step4DataStore[p.programId]
            if (step4Data) {
                let s4Data = {
                    createdBy: currentUser,
                    dateCreated: dt.toISOString(),
                    modifiedBy: currentUser,
                    dateModified: dt.toISOString()
                }
                if (step4CompletionData[p.programId].completed) {
                    s4Data["completed"] = step4CompletionData[p.programId].completed
                    s4Data["dateCompleted"] = step4CompletionData[p.programId].dateCompleted
                    s4Data["completedBy"] = step4CompletionData[p.programId].completedBy
                } else {
                    s4Data["completed"] = false
                    s4Data["dateCompleted"] = ""
                    s4Data["completedBy"] = ""
                }
                let s4SloData = []
                availableLearningOutcomes[p.programId].map(slo=> {
                    if (slo.sloId in step4Data) {
                        s4SloData.push({
                            sloId: slo.sloId,
                            resultsSummary: step4Data[slo.sloId].summaryOfResults,
                            focusAreaReflection: step4Data[slo.sloId].reflectionOnHypothesis,
                            interpretationOfResults: step4Data[slo.sloId].interpretationOfResults,
                            followUpQuestions: step4Data[slo.sloId].followUpQuestions,
                            actionsForImprovement: step4Data[slo.sloId].actionsForImprovement
                        })
                    }
                })
                if (s4SloData.length > 0) {
                    s4Data["learningOutcomes"] = s4SloData
                }
                programAssessment["step4Data"] = s4Data
            } // --end step 4

            let step5Tab1Data = step5Tab1DataStore[p.programId]
            let step5Tab2Data = step5Tab2DataStore[p.programId]
            if (step5Tab1Data || step5Tab2Data) {
                let s5Data = {
                    createdBy: currentUser,
                    dateCreated: dt.toISOString(),
                    modifiedBy: currentUser,
                    dateModified: dt.toISOString()
                }
                if (step5CompletionData[p.programId].completed) {
                    s5Data["completed"] = step5CompletionData[p.programId].completed
                    s5Data["dateCompleted"] = step5CompletionData[p.programId].dateCompleted
                    s5Data["completedBy"] = step5CompletionData[p.programId].completedBy
                } else {
                    s5Data["completed"] = false
                    s5Data["dateCompleted"] = ""
                    s5Data["completedBy"] = ""
                }
                let s5SloData = []
                availableLearningOutcomes[p.programId].map(slo=> {
                    let sloData = {}
                    if (slo.sloId in step5Tab1Data || slo.sloId in step5Tab2Data) {
                        sloData["sloId"] = slo.sloId
                    }
                    if (slo.sloId in step5Tab1Data) {
                        sloData["cycleSecondDataCollection"] = step5Tab1Data[slo.sloId].s5q30
                        sloData["changesPlanned"] = step5Tab1Data[slo.sloId].s5q1
                        sloData["dataMotivation"] = step5Tab1Data[slo.sloId].s5q2
                        sloData["changeHypothesis"] = step5Tab1Data[slo.sloId].s5q3
                        sloData["facultyCommunicationAboutChange"] = step5Tab1Data[slo.sloId].s5q15

                        if (step5Tab1Data[slo.sloId].s5q4) { 
                            sloData["changeInApproach"] = step5Tab1Data[slo.sloId].s5q4
                        }
                        if (step5Tab1Data[slo.sloId].s5q5) { 
                            sloData["changesInFaculty"] = step5Tab1Data[slo.sloId].s5q5
                        }
                        if (step5Tab1Data[slo.sloId].s5q6) { 
                            sloData["approachToolChanges"] = step5Tab1Data[slo.sloId].s5q6
                        }
                        if (step5Tab1Data[slo.sloId].s5q7) { 
                            sloData["facultyDevelopment"] = step5Tab1Data[slo.sloId].s5q7
                        }
                        if (step5Tab1Data[slo.sloId].s5q8) { 
                            sloData["courseContentChanges"] = step5Tab1Data[slo.sloId].s5q8
                        }
                        if (step5Tab1Data[slo.sloId].s5q9) { 
                            sloData["courseSequencePrerequisiteChanges"] = step5Tab1Data[slo.sloId].s5q9
                        }
                        if (step5Tab1Data[slo.sloId].s5q10) { 
                            sloData["gradingMethodologyChanges"] = step5Tab1Data[slo.sloId].s5q10
                        }
                        if (step5Tab1Data[slo.sloId].s5q11) { 
                            sloData["assignmentRevisionChanges"] = step5Tab1Data[slo.sloId].s5q11
                        }
                        if (step5Tab1Data[slo.sloId].s5q12) { 
                            sloData["budgetaryReallocationChanges"] = step5Tab1Data[slo.sloId].s5q12
                        }
                        if (step5Tab1Data[slo.sloId].s5q13) { 
                            sloData["otherChanges"] = step5Tab1Data[slo.sloId].s5q13
                        }
                    }
                    if (slo.sloId in step5Tab2Data) {
                        sloData["secondRoundToolDescription"] = step5Tab2Data[slo.sloId].s5q17
                        sloData["secondRoundCoursesAssessed"] = step5Tab2Data[slo.sloId].s5q18
                        sloData["brightspaceAutomation"] = step5Tab2Data[slo.sloId].s5q19
                        sloData["secondRoundDataCollection"] = step5Tab2Data[slo.sloId].s5q20
                    }

                    if ("sloId" in sloData) {
                        s5SloData.push(sloData)
                    }
                })
                if (s5SloData.length > 0) {
                    s5Data["learningOutcomes"] = s5SloData
                }
                programAssessment["step5Data"] = s5Data
            } // --end of Step 5

            if (p.programId in step6CompletionData) {
                let s6Data = {
                    secondAssessmentCompleted: step6CompletionData[p.programId].completed,
                    createdBy: currentUser,
                    dateCreated: dt.toISOString(),
                    modifiedBy: currentUser,
                    dateModified: dt.toISOString()
                }

                if (step6CompletionData[p.programId].completed) {
                    s6Data["completed"] = step6CompletionData[p.programId].completed
                    s6Data["dateCompleted"] = step6CompletionData[p.programId].dateCompleted
                    s6Data["completedBy"] = step6CompletionData[p.programId].completedBy
                } else {
                    s6Data["completed"] = false
                    s6Data["dateCompleted"] = ""
                    s6Data["completedBy"] = ""
                }

                programAssessment["step6Data"] = s6Data
            } // --end step 6

            let step7Tab1Data = step7Tab1DataStore[p.programId]
            let step7Tab2Data = step7Tab2DataStore[p.programId]
            
            if ((step7Tab1Data && Object.keys(step7Tab1Data).length > 0)
                    || (step7Tab2Data && Object.keys(step7Tab2Data).length > 0)) {
                let s7Data = {
                    createdBy: currentUser,
                    dateCreated: dt.toISOString(),
                    modifiedBy: currentUser,
                    dateModified: dt.toISOString()
                }

                let finalReflection = {}
                if ("s7q1" in step7Tab2Data) {
                    finalReflection['themeLessonsLearned'] = step7Tab2Data.s7q1
                }
                if ("s7q2" in step7Tab2Data) {
                    finalReflection['longTermProgramChanges'] = step7Tab2Data.s7q2
                }
                if ("s7q3" in step7Tab2Data) {
                    finalReflection['studentAchievementChanges'] = step7Tab2Data.s7q3
                }
                if ("s7q4" in step7Tab2Data) {
                    finalReflection['externalFactors'] = step7Tab2Data.s7q4
                }

                if (Object.keys(finalReflection).length > 0) {
                    s7Data['finalReflection'] = finalReflection
                    s7Data['finalReflection'].createdBy = currentUser
                    s7Data['finalReflection'].dateCreated = dt.toISOString()
                    s7Data['finalReflection'].modifiedBy = currentUser
                    s7Data['finalReflection'].dateModified = dt.toISOString()
                    if (step7Tab2CompletionData[p.programId].completed) {
                        s7Data['finalReflection'].completed = step7Tab2CompletionData[p.programId].completed
                        s7Data['finalReflection'].dateCompleted = step7Tab2CompletionData[p.programId].dateCompleted
                        s7Data['finalReflection'].completedBy = step7Tab2CompletionData[p.programId].completedBy
                    } else {
                        s7Data['finalReflection'].completed = false
                        s7Data['finalReflection'].dateCompleted = ""
                        s7Data['finalReflection'].completedBy = ""
                    }
                }

                if (step7CompletionData[p.programId].completed) {
                    s7Data["completed"] = step7CompletionData[p.programId].completed
                    s7Data["dateCompleted"] = step7CompletionData[p.programId].dateCompleted
                    s7Data["completedBy"] = step7CompletionData[p.programId].completedBy
                } else {
                    s7Data["completed"] = false
                    s7Data["dateCompleted"] = ""
                    s7Data["completedBy"] = ""
                }

                let s7SloData = []
                availableLearningOutcomes[p.programId].map(slo=> {
                    if (step5Tab1Data && (slo.sloId in step5Tab1Data)) {
                        s7SloData.push({
                            sloId: slo.sloId,
                            summaryOfResults: step7Tab1Data[slo.sloId].s7q1,
                            interpretationOfBothRounds: step7Tab1Data[slo.sloId].s7q2,
                            followUpAndNextSteps: step7Tab1Data[slo.sloId].s7q3
                        })
                    }
                })
                if (s7SloData.length > 0) {
                    s7Data["learningOutcomes"] = s7SloData
                }
                programAssessment["step7Data"] = s7Data
            } // --end of Step 7

            formattedAssessmentData.push(programAssessment)
        }
    })

    return formattedAssessmentData;
}